import { c as _c } from "react/compiler-runtime";
import type { SessionFeedProps } from './types';
import { CloudSessionFeed } from './cloud-feed';
import { LocalSessionFeed } from './local/local-feed';
import { isLocalSessionId } from './session-id';

/**
 * Each runtime's feed is a component because the cloud's channel is a hook (`useRealtime`): a
 * session of the other runtime mounts the other feed in its place.
 */
export function SessionFeed(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = isLocalSessionId(props.sessionId) ? <LocalSessionFeed {...props} /> : <CloudSessionFeed {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}